import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import AgentAuditOperationDetail from '../Components/AgentAuditOperationDetail';
import { useAlert } from '../Components/AlertContext';
import Breadcrumbs from '../Components/Breadcrumbs';
import Button from '../Components/Buttons';
import PageLoader from '../Components/PageLoader';
import { TaskScheduleApiProvider, useTaskScheduleApi } from '../Services/TaskScheduleApiProvider';
import { AuditOperation } from '../Services/TaskScheduleApiProviderTypes';

function TaskScheduleExecutionAuditOperationContent() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const { organizationId, taskScheduleId, executionId, operationId } = useParams();
  const [searchParams] = useSearchParams();
  const assistantId = searchParams.get('assistantId');

  const { getExecutionAuditOperation } = useTaskScheduleApi();

  const getExecutionAuditOperationRef = useRef(getExecutionAuditOperation);
  getExecutionAuditOperationRef.current = getExecutionAuditOperation;

  const [loading, setLoading] = useState<boolean>(true);
  const [detailAudit, setDetailAudit] = useState<AuditOperation | null>(null);

  useEffect(() => {
    if (!assistantId || !operationId) {
      setLoading(false);
      return;
    }

    const fetch = async () => {
      try {
        setLoading(true);
        const detail = await getExecutionAuditOperationRef.current(assistantId, operationId);
        setDetailAudit(detail);
      } catch (error) {
        showAlert('fail', 'Failed to fetch audit operation');
      } finally {
        setLoading(false);
      }
    };

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assistantId, operationId]);

  const handleBack = () => {
    const qs = assistantId ? `?assistantId=${assistantId}` : '';
    navigate(
      `/organizations/${organizationId}/task-schedule/${taskScheduleId}/executions/${executionId}${qs}`,
    );
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="container">
      <Breadcrumbs />
      <div className="radius-yes p-2 bg-yes col-12 h-100">
        <AgentAuditOperationDetail agentAudit={detailAudit} onClose={handleBack} showId={true} />
        <div className="buttons-container justify-end gap-12">
          <Button background="color2" size="medium" onClick={handleBack}>
            Back
          </Button>
        </div>
      </div>
    </div>
  );
}

function TaskScheduleExecutionAuditOperation() {
  return (
    <TaskScheduleApiProvider>
      <TaskScheduleExecutionAuditOperationContent />
    </TaskScheduleApiProvider>
  );
}

export default TaskScheduleExecutionAuditOperation;
